import type {
  PortName,
  PortNameApi,
  PortNameFilters,
  PortNameFiltersUpdateApi,
  PortNames,
  PortNamesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizePortName = (portName: PortNameApi): PortName => ({
  ...portName,
  label: portName.name,
});

export const normalizePortNames = (response: PortNamesApi): PortNames => {
  const list = (response.items ?? []).sort((a, b) => a.name.localeCompare(b.name)).map(normalizePortName);

  return {
    list,
    map: list.reduce(
      (acc, portName) => {
        acc[String(portName.id)] = portName;
        return acc;
      },
      {} as PortNames['map'],
    ),
  };
};

export const normalizePortNameFilters = (filters: Partial<PortNameFilters>): PortNameFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'name asc',
  };
};
